import { Box, Button, Container, Divider, IconButton, Modal, Typography, MenuItem, Select, InputLabel, FormControl } from '@mui/material'
import React, { useCallback, useState, useEffect } from 'react'
// import Spinner from "../Component/spinner/spinner";
import { usePaginationSpotLightMutation } from '../../../app/services/spotlightService'
import CloseIcon from '@mui/icons-material/Close'
import ReactPaginate from "react-paginate"; // Import CSS file for pagination styles
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'

const ViewSpotLight = () => {
    const [page, setPage] = useState(0)
    const [spotlights, setSpotlights] = useState([])
    const [PaginationSpotLight] = usePaginationSpotLightMutation()
    const [open, setOpen] = useState(false);
    const [selectedSpotlight, setSelectedSpotlight] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [totalPages, setTotalPages] = useState()
    const [itemsPerPage, setItemsPerPage] = useState(9);
    const [error, setError] = useState("");

    const style1 = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        placeItems: "center",
        // width:'700px',
        maxWidth: "40%",
        bgcolor: "background.paper",
        boxShadow: 24,
        borderRadius: "5px",
        padding: 4,
        height: "75vh",
        zIndex: "9999999",
    };

    const handlePageClick = ({ selected }) => {
        setSearchTerm('')
        setError("");
        setPage(selected);
    };

    const handleOpen = (spotlight) => {
        setSelectedSpotlight(spotlight);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    // const handlePageChange = () => {
    //     const pageNumber = Number(searchTerm);
    //     if (isNaN(pageNumber) || pageNumber < 0) {
    //       setError("Page number cannot be less than 1");
    //     } else if (pageNumber > totalPages) {
    //       setError("Please enter valid page number");
    //     } else if (pageNumber === 0) {
    //       setError("Please enter page number");
    //     } else {
    //       setError("");
    //       setPage(pageNumber - 1);
    //     }
    //   };
    const handlePageChange = () => {
        const pageNumber = Number(searchTerm);
        if (!Number.isInteger(pageNumber) || pageNumber < 1) {
            setError("Please enter a  page number");
            return;
        }
        if (pageNumber > totalPages) {
            setError(`Please enter a valid page number`);
            return;
        }
        setError("");
        setPage(pageNumber - 1); // Convert to zero-based index
    };
    const fetchSpotLight = useCallback(async () => {
        const data = {
            page: page + 1,
            itemsPerPage,
            role: "",
        };
        try {
            const res = await PaginationSpotLight(data);
            if (res?.data?.status) {
                setSpotlights(res.data.data.spotLightDetails);
                const totalPages = Math.ceil(res?.data?.data?.totalCount / itemsPerPage);
                setTotalPages(totalPages)
            } else {
                console.error("Failed to fetch spotlight data.");
            }
        } catch (error) {
            console.error("Error fetching spotlight data:", error);
        }
    }, [PaginationSpotLight, page, itemsPerPage]);

    // Trigger fetch on dependencies change
    useEffect(() => {
        fetchSpotLight();
    }, [fetchSpotLight]);
    return (
        <div className='page-containter'>
            <div className='pt-5 mb-3'></div>
            <div className="upcoming-class alata-bold">View SpotLight</div>
            <div className='containter-fluid '>
                <div className="bg-light-green text-end px-md-5 px-3 pt-3 py-3">
                    <Button
                        onClick={() => window.history.back()}
                        variant="contained"
                        className="menus-color me-4 mb-3"
                    >
                        Back
                    </Button>

                    <div className="row justify-content-center overallSpotPadding">
                        {spotlights && spotlights.length > 0 ? (
                            spotlights.filter(sl => sl?.isDeleted === 0).map((spotlight) => (
                                <div className="col-md-4 mb-3" key={spotlight._id}>
                                    <div className="bg-white h-100 d-flex justify-content-between flex-column">
                                        {/* <div className="bg-white h-100 d-flex justify-content-between flex-column"> */}
                                        <div className='d-flex justify-content-center align-items-center py-3'>
                                            <img key={spotlight?.image} src={`${spotlight?.image}?t=${new Date().getTime()}`} alt={spotlight._id} className='aspect4' width={120} height={120} />
                                        </div>
                                        <div className='d-flex justify-content-center align-items-center backgroud-sportlight-Text mb-3 '>
                                            <h6 className='fw-bold poppins-semibold menus-green-color text-center text-capitalize px-3 title-font'>{spotlight?.heading}</h6>
                                        </div>
                                        <div className='pb-2'>
                                            <p className='spotlight-content poppins-light fs-6 justified px-3 content-font'>{spotlight?.content.length > 150 ? spotlight?.content.slice(0, 150) + "...." : spotlight?.content}</p>
                                        </div>
                                        <div className="d-flex justify-content-center align-items-end mb-3">
                                            <Button
                                                className="spot-light-button dynamicButton content-font"
                                                style={{ color: '#ffffff', borderRadius: 0, textTransform: 'none' }}
                                                variant="contained"
                                                onClick={() => handleOpen(spotlight)}
                                            >
                                                Know More
                                            </Button>
                                        </div>
                                    </div>

                                </div>
                            ))
                        ) : (
                            <div className="col-12 content-font">
                                <div className='d-flex justify-content-center'>
                                    <ErrorOutlineIcon style={{ fontSize: 50, color: 'red' }} />
                                    <h3 className="text-danger">Will Be Added Shortly</h3>
                                </div>
                            </div>
                        )}
                    </div>
                    {(Object.keys(spotlights)?.length !== 0) &&
                        <div className="d-flex justify-content-between flex-md-row flex-column gx-3 gx-md-0 content-font" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "20px", marginBottom: "56px" }}>
                            <div className="mb-2 mb-md-0">
                                <div className="d-flex gap-2">
                                    <input
                                        type="number"
                                        min={1}
                                        placeholder="Page no."
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                        className="search-input"
                                    />
                                    <div className="goPage cursor-pointer" onClick={handlePageChange}>
                                        <h5 className="p-2 m-0">Go</h5>
                                    </div>
                                </div>
                                {error && <p style={{ color: "red", fontSize: "14px" }}>{error}</p>}
                            </div>
                            <div className="my-3 my-lg-0">
                                <ReactPaginate
                                    pageCount={totalPages} // Replace with the total number of pages
                                    pageRangeDisplayed={1}
                                    marginPagesDisplayed={1}
                                    onPageChange={handlePageClick}
                                    containerClassName={"pagination"}
                                    activeClassName={"active"}
                                    previousLabel={(page + 1) > 1 ? "Previous" : null}
                                    // nextLabel={currentPage > 1 && page + 1 !== currentPage ? "Next" : null}
                                    nextLabel={((page + 1) > (totalPages - 1)) ? null : "Next"}
                                    disabledClassName={"disablebtn"}
                                    forcePage={page}
                                />

                            </div>
                            <div className="mb-2 mb-md-0">
                                <FormControl variant="outlined">
                                    <InputLabel></InputLabel>
                                    <Select
                                        className="itemsperpage spotlightDropdown"
                                        value={itemsPerPage}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setItemsPerPage(value);
                                            setError('')
                                            setSearchTerm('');
                                            setPage(0)
                                        }}
                                        MenuProps={{
                                            MenuListProps: {
                                                sx: {
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                },
                                            },
                                        }}
                                    >
                                        <MenuItem value={9} className="Event-menu">9</MenuItem>
                                        <MenuItem value={18} className="Event-menu">18</MenuItem>
                                        <MenuItem value={45} className="Event-menu">45</MenuItem>
                                        <MenuItem value={90} className="Event-menu">90</MenuItem>
                                    </Select>
                                </FormControl>
                            </div>
                        </div>
                    }
                </div>
            </div>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                className='spotlight-modal'
            >
                <Box
                    sx={style1}
                    className="d-flex align-items-center flex-column gap-3 overflow-x-hidden"

                >
                    <Container maxWidth={false} sx={{ px: 3 }}>
                        <Box className="d-flex justify-content-between py-2">

                            <Typography variant="h5" sx={{ color: "#0d4022", fontWeight: "bold" }} >
                                View Spotlights
                            </Typography>
                            <IconButton onClick={handleClose} aria-label="Close">
                                <CloseIcon />
                            </IconButton>
                        </Box>

                        {/* Centered Divider */}
                        <Box display="flex" justifyContent="center" width="100%">
                            <Divider className="black-line-for-modal mb-0" sx={{ width: "100%" }} />
                        </Box>

                        <div className="d-flex justify-content-center">
                            <h2
                                className="alata-regular fs-5 text-center py-2"
                                style={{ color: "#611f1e" }}
                            >
                                {selectedSpotlight?.heading}
                            </h2>
                        </div>
                        <div className="d-flex justify-content-center">
                            <div >
                                <img
                                    src={selectedSpotlight?.image}
                                    className="img-fluid"
                                    alt="img"
                                />
                            </div>
                        </div>
                        <div className="text-justify" >
                            <p className="alata-regular spotlight-text-justify p-0 my-3" >
                                {selectedSpotlight?.content}
                            </p>
                        </div>
                    </Container>
                </Box>
            </Modal>
        </div>
    )
}

export default ViewSpotLight
